module.exports = __webpack_public_path__ + "static/img/login-lg.73c4c60.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/login-lg.png
// module id = wGeU
// module chunks = 1